const blue = Object.freeze({
  blue100: '#E8F3FF',
  blue200: '#C1DFFF',
  blue300: '#ADD5FF',
  blue400: '#72B7FF',
  blue500: '#3799FF',
  blue600: '#0071E8',
  blue700: '#0054AD',
  blue800: '#004186',
  blue900: '#1F3A74',
  blue1000: '#0E1B36'
});
const orange = Object.freeze({
  orange100: '#FCE8D9',
  orange200: '#F9D1B5',
  orange300: '#F6BB90',
  orange400: '#F4A46C',
  orange500: '#F18E47',
  orange600: '#EE7723',
  orange700: '#D96411',
  orange800: '#B5530E',
  orange900: '#90420B',
  orange1000: '#6C3108'
});
const neutral = Object.freeze({
  neutral100: '#F9F9F9',
  neutral200: '#E5E5E5',
  neutral300: '#D9D9D9',
  neutral400: '#BEBEBE',
  neutral500: '#ABABAB',
  neutral600: '#979797',
  neutral700: '#7A7A7A',
  neutral800: '#666666',
  neutral900: '#494949',
  neutral1000: '#353535'
});
const green = Object.freeze({
  green000: '#DBF8E4',
  green100: '#26C255',
  green200: '#23B14E',
  green300: '#1FA146',
  green400: '#1C903F',
  green500: '#198038',
  green600: '#167031'
});
const yellow = Object.freeze({
  yellow000: '#FDF1DC',
  yellow100: '#F9CC7E',
  yellow200: '#F8C46C',
  yellow300: '#F7BD59',
  yellow400: '#F6B646',
  yellow500: '#F5AE34',
  yellow600: '#F4A721'
});
const red = Object.freeze({
  red000: '#FCE8E9',
  red100: '#E64C55',
  red200: '#E43B44',
  red300: '#E22A34',
  red400: '#DA1E28',
  red500: '#C91C25',
  red600: '#B81922'
});
const coral = Object.freeze({
  coral000: '#FFE8DE',
  coral100: '#F8D2C1',
  coral200: '#F3B89E',
  coral300: '#EF9F7B',
  coral400: '#EB8558',
  coral500: '#E97846',
  coral600: '#E76B35'
});
const shades = Object.freeze({
  black: '#000000',
  white: '#ffffff',
  transparent: '#ffffff00'
});

export default Object.freeze({
  blue,
  orange,
  neutral,
  green,
  yellow,
  red,
  coral,
  shades
});
